import { createUseStyles } from 'react-jss'

import { tabletDown } from '../../../../styles/const/breakpoints'

const useStyles = createUseStyles({
  graphsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, calc((100% - 40px) / 2))',
    gridGap: 40,
    marginTop: 40
  },
  errorMessage: {
    textAlign: 'center',
    marginTop: 40
  },
  [`@media screen and (${tabletDown})`]: {
    graphsContainer: {
      display: 'flex',
      flexDirection: 'column'
    }
  }
})

export default useStyles
